module.exports = __webpack_public_path__ + "img/close_black.51fc71e6.svg";